var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDowncarrot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true",
    className: "globalNav-1216 globalNav-1224 globalNav-1230",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11h8L8 5l-4 6z",
    fill: "white",
    className: "globalNav-1226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowncarrot);
export default __webpack_public_path__ + "static/media/downcarrot.f52d669e340b08526655177a31026760.svg";
export { ForwardRef as ReactComponent };